'use client'

import { News as news } from '@/@types/index'
import { NewCard } from '../news/NewCard'
import { ROUTES } from '@/config/routes'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { useRef } from 'react'
import { HomeSection } from "./HomeSection"

type Props = {
  news: news[]
}

export const News = ({ news }: Props) => {
  const lastThreeNews = [...news]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 4)
  const swiperRef = useRef<any>(null)

  return (
    <HomeSection
      title="NOTICIAS"
      viewAllLink={ROUTES.news.root}
      backgroundImage="/bg-pattern-sucio-antiguo.webp"
      overlayColor="bg-black/70"
      className="lg:pb-40"
      titleColor="text-white"
    >
      <div className="relative">
        <Swiper
          modules={[Navigation]}
          spaceBetween={26}
          slidesPerView={1.2}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2.2 },
            1024: { slidesPerView: 4 },
          }}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className="pb-8"
        >
          {lastThreeNews.map((item) => (
            <SwiperSlide key={item.id}>
              <NewCard newItem={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </HomeSection>
  )
}
